/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthentificationService } from './authentification.service';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

  constructor(private readonly authentificationService: AuthentificationService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${this.authentificationService.getToken()}`
      }
    });
    return next.handle(req);
  }
}
